import * as React from "react";
import {css} from "@emotion/react";

export const style = {
    container: css`
      width: 100%;
      max-width: 400px;
    `,
}